import clsx from "clsx";
import dayjs from "dayjs";
import { HemeryLogoIcon } from "ui/iconsN";

type SheetProps = {
  travelId: number;
  travelTitle: string;
  travelImage: { id: number; realname: string; name: string; caption: string } | null;
  dateStart: string | null;
  dateEnd: string | null;
  countries: Array<{ title: string; alias: string | null }>;
};
type Props = SheetProps & {
  className?: string;
  type: "banner" | "popup";
};
const IntermedesLogo = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 419.21 103.15" className={className}>
    <path d="M0 63.33V21.11h6.44v42.22H0zm0-48.37V8.82h6.44v6.14H0zm49.51 48.37V37.64c0-7.38-3.98-11.1-10.26-11.1-6.27 0-10.34 3.82-10.34 11.1v25.69h-6.1V21.62h6.1v4.58c2.97-3.39 7.04-5.08 11.7-5.08 4.49 0 8.14 1.36 10.68 3.9 2.97 2.88 4.32 6.78 4.32 11.61v26.71h-6.1v-.01zm32.63 0c-7.12 0-10.68-5-10.68-11.19v-25.6H66.2v-4.66h5.26V8.82h6.1v13.05h8.9v4.66h-8.9v25.43c0 3.82 1.78 6.1 5.68 6.1h3.22v5.26h-4.32v.01zm40.35-30.78c-1.61-3.82-5.34-6.27-9.75-6.27s-8.14 2.46-9.75 6.27c-.93 2.29-1.1 3.56-1.27 6.95h22.04c-.17-3.39-.34-4.66-1.27-6.95zm-20.77 11.53c0 9.15 4.32 14.41 12.29 14.41 4.83 0 7.63-1.44 10.94-4.75l4.15 3.64c-4.24 4.24-8.14 6.45-15.26 6.45-11.02 0-18.22-6.62-18.22-21.37 0-13.48 6.52-21.36 17.12-21.36 10.76 0 17.12 7.8 17.12 20.17v2.8h-28.14v.01zm64.42-14.5c-2.29-2.29-3.98-3.05-7.2-3.05-6.1 0-10 4.83-10 11.19v25.6h-6.1v-41.7h6.1v5.09c2.29-3.47 6.87-5.59 11.7-5.59 3.98 0 7.04.93 10 3.9l-4.5 4.56zm65.96 33.75V37.64c0-7.38-3.99-11.1-10.26-11.1-6.1 0-10.43 3.82-10.43 10.43v26.37h-6.1v-25.7c0-7.38-3.99-11.1-10.26-11.1s-10.43 3.82-10.43 11.1v25.69h-6.1V21.62h6.1v4.58c2.97-3.39 7.12-5.08 11.78-5.08 5.76 0 10.26 2.37 12.8 6.95 3.22-4.58 7.88-6.95 13.73-6.95 4.49 0 8.22 1.44 10.77 3.9 2.97 2.88 4.49 6.78 4.49 11.61v26.71h-6.09v-.01zm34.59-50.36L257.53 0h7.29l7.45 12.97h-5.58zm10.93 19.58c-1.61-3.82-5.34-6.27-9.74-6.27-4.41 0-8.14 2.46-9.75 6.27-.93 2.29-1.1 3.56-1.27 6.95h22.04c-.18-3.39-.35-4.66-1.28-6.95zm-20.77 11.53c0 9.15 4.32 14.41 12.29 14.41 4.83 0 7.63-1.44 10.93-4.75l4.15 3.64c-4.24 4.24-8.13 6.45-15.25 6.45-11.02 0-18.23-6.62-18.23-21.37 0-13.48 6.53-21.36 17.13-21.36 10.76 0 17.12 7.8 17.12 20.17v2.8h-28.14v.01zm55.53-17.55c-9.07 0-10.51 7.8-10.51 15.94s1.44 15.94 10.51 15.94 10.43-7.8 10.43-15.94c-.01-8.14-1.36-15.94-10.43-15.94zm10.51 36.8v-5c-3.4 4.41-7.29 5.51-11.87 5.51-4.23 0-7.97-1.44-10.17-3.65-4.24-4.24-5.09-11.19-5.09-17.72 0-6.53.85-13.48 5.09-17.72 2.2-2.2 5.93-3.64 10.17-3.64 4.58 0 8.4 1.02 11.79 5.34V2.96h6.1v60.36h-6.02v.01zm45.86-30.78c-1.61-3.82-5.34-6.27-9.75-6.27s-8.14 2.46-9.75 6.27c-.93 2.29-1.1 3.56-1.27 6.95h22.05c-.18-3.39-.35-4.66-1.28-6.95zm-20.77 11.53c0 9.15 4.32 14.41 12.29 14.41 4.83 0 7.63-1.44 10.93-4.75l4.15 3.64c-4.24 4.24-8.14 6.45-15.26 6.45-11.02 0-18.22-6.62-18.22-21.37 0-13.48 6.53-21.36 17.12-21.36 10.76 0 17.12 7.8 17.12 20.17v2.8h-28.13v.01zm54.25 19.75c-7.03 0-12.54-1.61-17.12-6.02l4.07-4.07c3.31 3.47 7.8 4.83 12.97 4.83 6.87 0 11.11-2.46 11.11-7.37 0-3.65-2.12-5.68-6.95-6.1l-6.87-.59c-8.14-.68-12.46-4.32-12.46-11.19 0-7.63 6.44-12.21 15.34-12.21 5.93 0 11.27 1.44 15.01 4.49l-3.99 3.98c-2.97-2.29-6.78-3.3-11.1-3.3-6.1 0-9.32 2.62-9.32 6.87 0 3.56 2.04 5.68 7.29 6.1l6.7.59c7.29.68 12.29 3.48 12.29 11.28-.01 8.05-6.88 12.71-16.97 12.71z" />
    <path d="M.17 102.99V83.91h2.04v17.25h9.75v1.83H.17zm24.2 0V83.91h11.85v1.82h-9.81v6.73h8.36v1.82h-8.36v6.88h9.81v1.83H24.37zm47.37 0h-1.67L63.8 83.91h2.15l4.95 15.43 4.96-15.43h2.15l-6.27 19.08zM98.8 86.93c-.83-.86-2.04-1.37-3.3-1.37s-2.47.51-3.29 1.37c-1.21 1.23-1.34 2.52-1.34 6.51 0 3.99.13 5.28 1.34 6.51.83.86 2.04 1.37 3.29 1.37s2.47-.51 3.3-1.37c1.21-1.23 1.34-2.52 1.34-6.51 0-3.99-.13-5.27-1.34-6.51zm1.58 14.23c-1.29 1.29-2.97 1.98-4.88 1.98-1.9 0-3.59-.7-4.88-1.98-1.8-1.79-1.8-3.67-1.8-7.72s0-5.92 1.8-7.72c1.29-1.29 2.97-1.98 4.88-1.98 1.9 0 3.59.7 4.88 1.98 1.8 1.79 1.8 3.67 1.8 7.72s0 5.93-1.8 7.72zm20.34-6.05v7.88h-2.03v-7.88l-5.68-11.2h2.2l4.5 9.13 4.44-9.13h2.2l-5.63 11.2zm21.84-8.28l-3.59 10.07h7.13l-3.54-10.07zm5.66 16.16l-1.53-4.31h-8.33l-1.53 4.31h-2.17l7.02-19.08h1.71l6.99 19.08h-2.16zm24.87-2.04c-1.34 1.45-3.13 2.2-5.09 2.2-1.88 0-3.59-.7-4.88-1.98-1.8-1.79-1.8-3.67-1.8-7.72s0-5.92 1.8-7.72c1.29-1.29 2.97-1.98 4.88-1.98 3.64 0 6.11 2.36 6.67 5.71h-2.04c-.54-2.41-2.25-3.88-4.64-3.88-1.26 0-2.47.51-3.29 1.37-1.21 1.23-1.34 2.52-1.34 6.51 0 3.99.14 5.3 1.34 6.54.83.86 2.04 1.34 3.29 1.34 1.39 0 2.73-.56 3.62-1.63.78-.94 1.07-1.98 1.07-3.46V94.8H168v-1.79h6.73v3.03c-.01 2.17-.46 3.65-1.64 4.91zm15.22 2.04V83.91h11.84v1.82h-9.8v6.73h8.35v1.82h-8.35v6.88h9.8v1.83h-11.84zm47.93.16c-1.88 0-3.59-.7-4.88-1.98-1.8-1.79-1.8-3.67-1.8-7.72s0-5.92 1.8-7.72c1.29-1.29 3-1.98 4.88-1.98 3.43 0 5.98 2.09 6.62 5.68h-2.09c-.51-2.33-2.14-3.86-4.53-3.86-1.26 0-2.47.48-3.29 1.34-1.21 1.23-1.34 2.54-1.34 6.54 0 3.99.14 5.3 1.34 6.54.83.86 2.04 1.34 3.29 1.34 2.39 0 4.07-1.53 4.58-3.86h2.04c-.62 3.59-3.22 5.68-6.62 5.68zm26.34 0c-3.86 0-6.65-2.65-6.65-6.46V83.91h2.04v12.62c0 2.89 1.82 4.8 4.61 4.8s4.64-1.9 4.64-4.8V83.91h2.04v12.78c-.01 3.8-2.82 6.46-6.68 6.46zm20.77-.16V83.91h2.04v17.25h9.75v1.83h-11.79zM311 85.73v17.26h-2.04V85.73h-5.51v-1.82h13.07v1.82H311zm24.31 17.42c-3.86 0-6.64-2.65-6.64-6.46V83.91h2.04v12.62c0 2.89 1.82 4.8 4.61 4.8s4.64-1.9 4.64-4.8V83.91H342v12.78c-.02 3.8-2.83 6.46-6.69 6.46zm27.89-17.42h-5.09v6.99h5.09c2.23 0 3.81-1.15 3.81-3.48s-1.58-3.51-3.81-3.51zm3.84 17.26l-4.34-8.47h-4.58v8.47h-2.04V83.91h7.31c3.33 0 5.65 2.01 5.65 5.31 0 2.79-1.69 4.61-4.15 5.12l4.53 8.65h-2.38zm15.46 0V83.91h11.84v1.82h-9.8v6.73h8.36v1.82h-8.36v6.88h9.8v1.83H382.5zm24.92 0V83.91h2.04v17.25h9.75v1.83h-11.79z" />
  </svg>
);

export const InfosupCover = ({ className, type, ...sheetProps }: Props) => {
  return (
    <div className={className}>
      <div
        className={clsx("scale-[0.1882] sm:scale-[0.2285]", {
          "origin-bottom-right -rotate-6": type === "popup",
          "origin-bottom-right sm:origin-bottom-left rotate-6": type === "banner",
        })}
      >
        <InfosupCoverSheet {...sheetProps} />
      </div>
    </div>
  );
};

export const InfosupCoverSheetHemerys = ({
  travelTitle,
  travelId,
  travelImage,
  dateStart,
  dateEnd,
  countries,
}: SheetProps) => {
  const sameMonth = dayjs(dateStart).isSame(dateEnd, "month");

  return (
    <div className="w-[595px] h-[842px] bg-[#12100F] flex flex-col items-center overflow-hidden">
      <div className="mt-[10px] flex flex-col items-center">
        <HemeryLogoIcon className="w-[190px]" />
        <div className="-mt-2 flex items-center gap-1.5">
          <span className="text-xs text-tx-2">par</span>
          <IntermedesLogo className="w-[76px] fill-white" />
        </div>
      </div>
      <div className="mt-[18px] h-[442px] w-[515px] shrink-0 overflow-hidden">
        {travelImage !== null && (
          <img
            alt="Couverture du voyage"
            className="h-full w-full object-cover"
            src={`https://assets.intermedes.voyage/images/travels/${travelId}/${travelImage.name}/640/${travelImage.realname}?ratio=107`}
            loading="lazy"
            decoding="async"
          />
        )}
      </div>
      <div className="mt-6 w-[515px] text-center">
        {countries.length !== 0 && (
          <p className="text-base font-semibold uppercase tracking-[1.92px] text-tx-2">
            {countries.map((country) => country.title).join(" - ")}
          </p>
        )}
        <p className="mt-4 font-serif text-[32px] leading-tight text-white">{travelTitle}</p>
        {dateStart !== null && dateEnd !== null && (
          <p className="mt-4 inline-block rounded-full bg-white/12 px-4 py-2 text-base text-white">
            Du {sameMonth ? dayjs(dateStart).format("DD") : dayjs(dateStart).format("DD MMMM")} au{" "}
            {dayjs(dateEnd).format("DD MMMM YYYY")}
          </p>
        )}
      </div>
    </div>
  );
};

export const InfosupCoverSheet = ({
  travelId,
  travelTitle,
  travelImage,
  dateStart,
  dateEnd,
  countries,
}: SheetProps) => {
  const destinationAlias = countries.length === 1 ? (countries[0]?.alias ?? null) : null;

  return (
    <div className="w-[595px] h-[842px] bg-white p-10">
      <div className="relative flex flex-col items-center">
        <IntermedesLogo className="w-[165px] fill-black" />
        <div className="w-full h-[555px] relative mt-[22px]">
          {travelImage !== null && (
            <img
              alt="Couverture du voyage"
              className="absolute w-full h-full object-cover"
              src={`https://assets.intermedes.voyage/images/travels/${travelId}/${travelImage.name}/640/${travelImage.realname}?ratio=66.66`}
              loading="lazy"
              decoding="async"
            />
          )}
          {destinationAlias !== null && (
            <img
              alt="Titre de la destination"
              className="absolute top-0 left-0 right-0"
              src={`https://assets.intermedes.voyage/images/asset/is_${destinationAlias}.png/640/is_${destinationAlias}.png`}
              loading="lazy"
              decoding="async"
            />
          )}
        </div>
      </div>
      <div className="w-full h-[147px]">
        <div className="flex flex-col justify-evenly w-full h-full text-center">
          <p className="font-bold text-[26px] leading-[30px]">{travelTitle}</p>
          {countries.length > 1 && (
            <p className="font-semibold text-[13px] uppercase tracking-[0.7px] text-[#B6917E]">
              {countries.map((country) => country.title).join(" - ")}
            </p>
          )}
          {dateStart !== null && dateEnd !== null && (
            <p className="font-semibold text-sm">
              Du {dayjs(dateStart).format("DD MMMM")} au {dayjs(dateEnd).format("DD MMMM YYYY")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
